<template>
  <a-popover v-model="visible" title="" trigger="click">
    <template slot="content">
      <div class="opt-wrap">
        <span
          class="opt-item"
          v-for="(opt, index) in optionList"
          :key="index"
          :class="['opt-item-' + item.optionType, item.curOption === opt.key ? 'cur-opt' : '']"
          @click="changeBrushOpt(opt)"
        >
          <i v-if="item.optionType === 'circle'" class="opt-circle" />
          <template v-else>{{ opt.name }}</template>
        </span>
      </div>
    </template>
    <SvgIcon :icon="item.icon" :is-keep="true" />
    <!-- <a-tooltip placement="bottom">
      <template slot="title">
        <span>{{ item.tip }}</span>
      </template>
      {{ item.tip }}
    </a-tooltip> -->
    <!-- <i class="operate-ico  n" :style="{ backgroundImage: 'url('+item.icon+')'}" /> -->
  </a-popover>
</template>
<script>
import SvgIcon from '@/components/SvgIcon.vue'
export default {
  components: {
    SvgIcon
  },
  props: {
    optionList: Array,
    item: Object
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    changeBrushOpt(opt) {
      this.visible = false
      this.$emit('changeBrushOpt', opt)
    }
  }
}
</script>
<style lang="less" scoped>
.opt-item {
  font-size: 14px;
  color: #303858;
  cursor: pointer;
  padding: 0 5px;
  .opt-circle {
    border-radius: 50%;
    background: #70788C;
    width: 8px;
    height: 8px;
    display: block;
  }
  &.cur-opt {
    font-weight: 700;
    color: #FF5C5C;
    .opt-circle {
      background: #FF5C5C;
    }
  }
  &:nth-child(2) {
    .opt-circle {
      border-width: 2px;
      width: 13px;
      height: 13px;
    }
  }
  &:nth-child(3) {
    .opt-circle {
      border-width: 3px;
      width: 15px;
      height: 15px;
    }
  }
}
.opt-wrap {
  width: 84px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>